import { Component, ElementRef, ViewChild, OnInit, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { PortalService } from '../services/portal.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import 'rxjs/add/observable/interval';
import { StatisticService } from './statistic.service';
import { SharedService } from '../common/shared.service';
import { Title }  from '@angular/platform-browser';
import { TopnavService } from '../header/topnav/topnav.service';
import { ISubscription } from 'rxjs/Subscription';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material';
import { Overlay, BlockScrollStrategy } from '@angular/cdk/overlay';
declare var google:any;

export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
  return () => overlay.scrollStrategies.block();
}

/**
 * Author: Redza Rosli
 * 
 * Date Created: May 30th 2018
 * 
 * Description: Component class for Online Statistics - /statistic
 **/
@Component({
  selector: 'gosg-statistic',
  templateUrl: './statistic.component.html',
  styleUrls: ['./statistic.component.css'],
  providers: [
    { provide: MAT_SELECT_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] }
  ]
})


export class StatisticComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("agencySelect") agencySelect: ElementRef;
  graphByYear: any =  [["01", 0, 0], ["02", 0, 0], ["03", 0, 0], ["04", 0, 0], ["05", 0, 0], ["06", 0, 0], ["07", 0, 0], ["08", 0, 0], ["09", 0, 0], ["10", 0, 0], ["11", 0, 0], ["12", 0, 0]];
  graphByYearCopy: any;
  StatByYearAll: any = [["01", "0"], ["02", "0"], ["03", "0"], ["04", "0"], ["05", "0"], ["06", "0"], ["07", "0"], ["08", "0"], ["09", "0"], ["10", "0"], ["11", "0"], ["12", "0"]];
  StatByYearNew: any = [["01", "0"], ["02", "0"], ["03", "0"], ["04", "0"], ["05", "0"], ["06", "0"], ["07", "0"], ["08", "0"], ["09", "0"], ["10", "0"], ["11", "0"], ["12", "0"]];
  StatByYearDservice: any = [{"name":"01","val":0},{"name":"02","val":0},{"name":"03","val":0},{"name":"04","val":0},{"name":"05","val":0},{"name":"06","val":0},{"name":"07","val":0},{"name":"08","val":0},{"name":"09","val":0},{"name":"10","val":0},{"name":"11","val":0},{"name":"12","val":0}];
  StatByYearPendingDservice: any = [{"name":"01","val":0},{"name":"02","val":0},{"name":"03","val":0},{"name":"04","val":0},{"name":"05","val":0},{"name":"06","val":0},{"name":"07","val":0},{"name":"08","val":0},{"name":"09","val":0},{"name":"10","val":0},{"name":"11","val":0},{"name":"12","val":0}];

  public yearList: any = [];

  public statAgcList:any = [];
  public statTrList:any = [];
  public flrTrList: any = [];
  statTrChartData: any = [];
  statTrPerAgc: any = [];

  public userColumnChart: string = 'block';
  public userPieChart: string = 'none;'
  public statAgcPSvcList:any = [];
  public statPSvcList:any = [];
  public flrPSvcList: any = [];
  statPSvcChartData: any = [];
  statPSvcPerAgc: any = [];

  public statAgcComSvcList:any = [];
  public statComSvcList:any = [];
  public flrSvcList: any = [];
  statComSvcChartData: any = [];
  statComSvcPerAgc: any = [];

  private twoSvcChartData: any =[];
  private twoSvcPerAgc: any =[];
  public twoAgcList: any = [];
  public twoSvcList: any = [];
  public newServiceData: any = [];

  statTrByYear: any =[["jan", 0], ["feb", 0], ["mar", 0], ["apr", 0], ["may", 0], ["jun", 0], ["jul", 0], ["aug", 0], ["sep", 0], ["oct", 0], ["nov", 0], ["dec", 0]];

  currAgencyCode: string;
  currTrCode: string;

  currPAgencyCode: string;
  currPSvcCode: string;
  
  currComAgencyCode: string;
  currComSvcCode: string; 

  StatByYearCounterDservice: any = [{"name":"01","val":0},{"name":"02","val":0},{"name":"03","val":0},{"name":"04","val":0},{"name":"05","val":0},{"name":"06","val":0},{"name":"07","val":0},{"name":"08","val":0},{"name":"09","val":0},{"name":"10","val":0},{"name":"11","val":0},{"name":"12","val":0}];
  allUsersByYear: any;
  newUsersByYear: any;
  dserviceByYear: any;
  pdserviceByYear: any;
  dserviceCounterByYear: any;
  allUsersData: any = [];
  newUsersData: any = [];
  dServiceData: any = [];
  dServicePendingData: any = [];
  dServiceCommonData: any = [];
  dserviceRpt: any;
  totalUsers: any;
  totalNewUsers: any;
  languageId; //= this.languageId;
  sum = (total, currentValue) => total + currentValue;
  loading:boolean = false;
  sub: any;
  newUsers: any;
  allUsers: any;
  statisticData: any;
  ostxn: any = [];
  themeColor: any;
  lang;

  private subscriptionLang: ISubscription;
  public subscriptionFontType: ISubscription;
  public fontType: string = 'Arial';
  private subscriptionFontSize: ISubscription;
  private subscriptionUserStat: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };

  private elOverallChart: any;
  private dataCheck = [];
  private getCurrYear = new Date().getFullYear();
  public selectedYear: number = new Date().getFullYear();

  constructor(
    private pageTitle: Title,
    private sharedService: SharedService,
    public portalservice: PortalService,
    private statisticservice: StatisticService,
    private translate: TranslateService,
    private topnavservice: TopnavService,
    @Inject(APP_CONFIG) private config: AppConfig) {

    this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {
      const myLang = this.translate.currentLang;

      if (myLang == 'en') {
        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'en';
          this.languageId = 1;
        });
      }

      if (myLang == 'ms') {
        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'ms';
          this.languageId = 2;
        });
      }

      if(this.topnavservice.flagLang){

        this.statisticData = this.statisticservice.getAllUserData();
        this.statisticData = this.statisticservice.getNewUserData();
        this.portalservice.triggerStatistic(1, this.selectedYear);
        this.portalservice.triggerStatistic(2, this.selectedYear);
        this.currAgencyCode = null;
        this.currTrCode = null;
        this.currPAgencyCode = null;
        this.currPSvcCode = null;
        this.currComAgencyCode = null;
        this.currComSvcCode = null;
        this.flrTrList = [];
        this.flrPSvcList = [];
        this.flrSvcList = [];
        this.twoAgcList =[];
        this.twoSvcList =[];
        this.userColumnChart = 'block';
        this.userPieChart = 'none';
        this.getDserviceReport(this.languageId, this.selectedYear);
        this.getPendingDserviceReport(this.languageId, this.selectedYear);
        //this.getDserviceCommonReport(this.languageId);
      }

      setTimeout(()=>{
        this.translate.get('pageTitle.home').subscribe((title:string) => {
          title = title + this.translate.instant('statistic.header');
          this.sharedService.setTitle(title);
        }); 
      },500);


    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
      $('.mat-tab-label').css('font-size', this.fontSize.sizeS);
      $('.mat-tab-link').css('font-size',  this.fontSize.sizeS);
      $('g > text').css('font-size', this.fontSize.sizeS);

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100); 
    });

    this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
      this.fontType = data;
    
      $('.mat-tab-label').css('font-family', this.fontType);
      $('.mat-tab-link').css('font-family',  this.fontType);
      $('.mat-select-value-text span').css('font-family', this.fontType);
      $('g > text').css('font-family', this.fontType);
    });

    this.subscriptionUserStat = this.statisticservice.statAllUpdated.subscribe((val)=> {
    
      if (val=='Users') {
        this.getUsersStatData(1);
        console.log(this.statisticservice.allUser);
        this.dataCheck.push({'name':'allUser'});
      }
   
      if (val == 'newUsers') {
        this.getUsersStatData(2);
        console.log(this.statisticservice.newUser); 
        this.dataCheck.push({'name':'newUser'}); 
      }

      if (this.dataCheck.filter(e => e.name === 'allUser').length > 0 && this.dataCheck.filter(e => e.name === 'newUser').length > 0) {
        this.generateUserChart();
      }

    });
  }
  

  ngOnInit() {

    if (!this.languageId) {
      if (localStorage.getItem('langID')) {
        this.languageId = localStorage.getItem('langID');
      } else { 
        this.languageId = 1;
      }
    }

    this.generateYearList();
       

    this.statisticData = this.statisticservice.getAllUserData();
    this.statisticData = this.statisticservice.getNewUserData();
    this.dataCheck = [];
    this.portalservice.triggerStatistic(1);
    this.portalservice.triggerStatistic(2);

    /*this.sub = Observable.interval(2000)
    .subscribe((val) => {
      console.log('ssss');
      console.log(val);
      this.getUsersStatData(1);
      this.getUsersStatData(2);
      this.sub.unsubscribe();
    }); */


    this.getDserviceReport(this.languageId);
    //this.getDserviceCommonReport(this.languageId);
    this.getPendingDserviceReport(this.languageId);
  

   
  }

  ngAfterViewInit() {
    
    // Get Title and Sent to GA
    this.translate.get('pageTitle.home').subscribe((title:string) => {
      title = title + this.translate.instant('statistic.header');
      this.sharedService.setTitleAndGtag(title);
    }); 

    this.sharedService.loadFontSizeData();
    this.sharedService.loadFontTypeData(); 

  }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
    this.subscriptionFontType.unsubscribe();
    this.subscriptionUserStat.unsubscribe();
  }

  generateUserChart(chartType?) {
    this.generateUserChartData();

    let vTitle = this.translate.instant('statistic.label.userchartvaxis');
    let hTitle = this.translate.instant('statistic.label.usercharthaxis');
     
      if (this.graphByYearCopy) {
        google.charts.setOnLoadCallback(()=> {
         
          drawChart(this.graphByYearCopy,vTitle,hTitle, chartType);
          setTimeout(()=>{
         
            $('g > text').css('font-size', this.fontSize.sizeS);
            $('g > text').css('font-family', this.fontType);
          },1000);
        });
      }
   
    function drawChart(graphData, vTitle, hTitle, chartType?) {
      if (!chartType) {
        chartType = 'ColumnChart';
      }
      let data = new google.visualization.arrayToDataTable(graphData);
      
      var view = new google.visualization.DataView(data);
      var view2 = new google.visualization.DataView(data);
      var viewPie1 = new google.visualization.DataView(data);
      var viewPie2 = new google.visualization.DataView(data);
      var yMax;
      var columnRange = data.getColumnRange(1);
      if (columnRange.max <5) {
        yMax = 5;
      } else {
        yMax = columnRange.max+(columnRange.max*0.01);
      }

      var groupData = google.visualization.data.group(data,
        [{column: 0, modifier: function () {return 'total'}, type:'string'}],
        [{column: 1, aggregation: google.visualization.data.sum, type: 'number'}]
      );
       var groupData2 = google.visualization.data.group(data,
        [{column: 0, modifier: function () {return 'total'}, type:'string'}],
        [{column: 2, aggregation: google.visualization.data.sum, type: 'number'}]
      );
            
        var formatPercent = new google.visualization.NumberFormat({
        pattern: '#,##0.0%'
      });
      //var formatShort = new google.visualization.NumberFormat({
      //  pattern: 'short'
      //});

      view.setColumns([0, 1,
        {
          calc: function (dt, row) {
            //var amount = formatShort.formatValue(dt.getValue(row, 1));
            var percent = formatPercent.formatValue(dt.getValue(row, 1) / groupData.getValue(0, 1));
            if (percent == 'NaN') {
              percent = '0.0%';
            }
            return percent;
          },
          type: 'string',
          role: "annotation"
        }, 2,
        {
          calc: function (dt, row) {
            //var amount = formatShort.formatValue(dt.getValue(row, 2));
            var percent = formatPercent.formatValue(dt.getValue(row, 2) / groupData2.getValue(0, 1));
            if (percent == 'NaN') {
              percent = '0.0%';
            }
            return percent;
          },

          type: "string",
          role: "annotation"
        }]);

      viewPie1.setColumns([0,1]);
      viewPie2.setColumns([0,2]);       
      let options = {
        height: 420,
        legend: { position: 'right', maxLines: 3 },
        isStacked: false,
        //colors: ['#05f7ec', '#dc3912'],
        vAxis: {
          title: vTitle,
          viewWindowMode:'explicit',
          logScale: true,
          viewWindow: {
            max: yMax, 
            min: 0
          }
        },
        hAxis: { title: hTitle },
        annotations: {
          alwaysOutside: true
        },
        series: {
          0: {
            annotations: {
              stem: {
                length: 20
              },
            },
          },
          1: {
            annotations: {
              stem: {
                length: 3
              }
            },
          },
        },
        pieSliceText: 'none',
        pieSliceTextStyle: {
          fontSize: 5
        },
        sliceVisibilityThreshold: 0.0000001,
        pieStartAngle: 80,
        //pieSliceText: 'value-and-percentage'
      };

      if (chartType == 'PieChart') {
        options.legend = { position: 'labeled', maxLines: 3};
        /*options.legend = {position: 'labeled', maxLines: 3}, {labeledValueText: 'both',
          textStyle: { 
              fontSize: 5
          }};*/
      } else {
        options["colors"] =['#05f7ec', '#dc3912'];
      }

      //let chart = new google.visualization.ColumnChart(document.getElementById('userChart'));
      //chart.draw(view, google.charts.Bar.convertOptions(options));
      var chart = new google.visualization.ChartWrapper({
        containerId: 'userChart'
     });

    var pieChart1 = new google.visualization.ChartWrapper({
      containerId: 'userChartPie1'
    });

    var pieChart2 = new google.visualization.ChartWrapper({
      containerId: 'userChartPie2'
    });

   

     
     if (chartType == 'ColumnChart') {
      chart.setOptions(options);
      chart.setChartType(chartType);
      chart.setDataTable(data);
      chart.draw();
    } else {
      pieChart1.setOptions(options);
      pieChart1.setChartType(chartType);
      pieChart1.setDataTable(viewPie1);
      pieChart1.draw();
      pieChart2.setOptions(options);
      pieChart2.setChartType(chartType);
      pieChart2.setDataTable(viewPie2);
      pieChart2.draw();
     }
     

     
      /*google.visualization.events.addListener(chart, 'select', function () {
        var selection = chart.getSelection();
        if (selection.length) {
          var row = selection[0].row;
          console.log(data.getValue(row, 0));
        }
      }); */
    }
  }

  generateAgcTrDrillChart(agencyCode, trCode, type?, chartType?) {
    console.log(agencyCode+'|'+trCode);
    let statData;
    let elementId;
    if (type == 'Pending') {
      statData = this.statPSvcChartData;
      elementId = 'pSvcChart';
    } else if (type == 'Common') {
      //statData = this.statComSvcChartData;
      statData = this.twoSvcChartData;
      elementId = 'comSvcChart';
    } else {
      statData = this.statTrChartData;
      elementId = 'trChart';
    }

    if (statData) {
    
        let flrData = statData.filter((element, index) => {
          return (element.agencyCode === agencyCode && element.trCode === trCode);
        });
        let gHeader = ['Month', this.translate.instant('statistic.label.total') + ' ' + this.translate.instant('statistic.label.transaction')];
        let chartData = JSON.parse(JSON.stringify(flrData[0].chartData));
        let title = flrData[0].agencyName + ' > ' + flrData[0].title;

        chartData.forEach(el => {
         let mName =  this.translate.instant('statistic.months.short.'+this.convertMonthName(el[0]));
         el[0] = mName;
        });
    
        chartData.unshift(gHeader);

        let vTitle = this.translate.instant('statistic.label.svcitemvaxis');
        let hTitle = this.translate.instant('statistic.label.svcitemhaxis');
       
        google.charts.setOnLoadCallback(()=> {
          drawChart(chartData, elementId, title, vTitle, hTitle, chartType);
          setTimeout(()=>{
            $('g > text').css('font-size', this.fontSize.sizeS);
            $('g > text').css('font-family', this.fontType);
          }, 1000);
        });
    }
    
    function drawChart(graphData, element, titleText, vTitle, hTitle, chartType?) {
      if (!chartType) {
        chartType = 'ColumnChart';
      }

      let data = new google.visualization.arrayToDataTable(graphData);
      var view = new google.visualization.DataView(data);
      var groupData = google.visualization.data.group(data,
        [{column: 0, modifier: function () {return 'total'}, type:'string'}],
        [{column: 1, aggregation: google.visualization.data.sum, type: 'number'}]
      );

      var formatPercent = new google.visualization.NumberFormat({
        pattern: '#,##0.0%'
      });

      function getText(val1, val2) {
        var percent = formatPercent.formatValue(val1 / val2);
        if (percent == 'NaN') {
          percent = '0.0%';
        }
        return percent;
      }

      view.setColumns([0, 1,
        {
          calc: function (dt, row) {
            //var amount = formatShort.formatValue(dt.getValue(row, 1));
            var percent = formatPercent.formatValue(dt.getValue(row, 1) / groupData.getValue(0, 1));
            if (percent == 'NaN') {
              percent = '0.0%';
            }
            return percent;
          },
          type: 'string',
          role: "annotation"
        }, {
          calc: function (dt, row) {
            return dt.getValue(row, 0) + ' - ' + dt.getFormattedValue(row, 1) + ' ('+ getText(dt.getValue(row, 1), groupData.getValue(0, 1)) + ')';
          },
          role: 'annotationText',
          type: 'string'
        }]);

      
      var columnRange = data.getColumnRange(1);
      let yMax;
      if (columnRange.max <5) {
        yMax = 5;
      } else {
        yMax = columnRange.max+(columnRange.max*0.01);
      }
      //if ((columnRange.max - columnRange.min) < 100) {
      //  yMin = 0;
      //  yMax = ((columnRange.max + columnRange.min) / 2) + 10;
      //} else {

      //}
      
      let options = {
        //title: titleText, 
        height: 520,
        width: '100%',
        isStacked: false,
        legend: {position:'none'},
        //colors: ['#05f7ec'],
        annotations: {
          textStyle: {
            color: 'black',
            bold: true,
            auraColor: 'transparent'
          },
          alwaysOutside: true
        },
        vAxis: {
          title: vTitle,
          logScale: true,
          viewWindowMode:'explicit',
          viewWindow: {
            max: yMax, 
            min: 0
          }
       },
       hAxis: { title: hTitle },
       pieSliceText: 'none',
       pieSliceTextStyle: {
       fontSize: 5
       },
       sliceVisibilityThreshold: 0.0000001,
       pieStartAngle: 10,
       //pieSliceText: 'value-and-percentage'
      };

      if (chartType == 'PieChart') {
        options.legend = { position: 'labeled'};
        //options.legend = { textStyle: {color: 'gray'}};
      } else {
        options["colors"] = ['#05f7ec'];
      }

      //let chart = new google.visualization.ColumnChart(document.getElementById(element));
      //chart.draw(view, google.charts.Bar.convertOptions(options));
      var chart = new google.visualization.ChartWrapper({
        containerId: element
     });

     chart.setOptions(options);
     chart.setChartType(chartType);
     chart.setDataTable(view);
     chart.draw();
  }
}

showChart(dataType, chartType) {
    //alert(this.currComAgencyCode);
    if (dataType == 'comSvcChart' && !this.currComSvcCode && this.currComAgencyCode) {
       return;
    } else if (dataType == 'pSvcChart' && !this.currPSvcCode && this.currPAgencyCode) {
        return;
    } else if (dataType == 'comSvcChart' && !this.currComSvcCode && !this.currComAgencyCode) {
      this.generateAgcTrChart('Common', chartType);
      $('#comSvcChartLabel').show(); 
    } else if (dataType == 'comSvcChart' && this.currComSvcCode) {
       this.generateAgcTrDrillChart(this.currComAgencyCode, this.currComSvcCode, 'Common', chartType);
      $('#comSvcChartLabel').show(); 
    } else if (dataType == 'pSvcChart' && !this.currPSvcCode && !this.currPAgencyCode) {
      this.generateAgcTrChart('Pending', chartType);
      $('#pSvcChartLabel').show();  
    } else if (dataType == 'pSvcChart' && this.currPSvcCode) {
      this.generateAgcTrDrillChart(this.currPAgencyCode, this.currPSvcCode, 'Pending', chartType);
      $('#pSvcChartLabel').show();  
    } else if (dataType == 'userChart') {
      if(chartType == 'PieChart') {
        this.userColumnChart = 'none';
        this.userPieChart = 'block';
      } else {
        this.userColumnChart = 'block';
        this.userPieChart = 'none';
      }
      this.generateUserChart(chartType); 
    }
}

  generateAgcTrChart(type?, chartType?) {
    let chartData; 
    let elementId;
    if (type == 'Pending') {
      chartData = this.statPSvcPerAgc;
      elementId = 'pSvcChart';
    } else if (type == 'Common') {
      //chartData = this.statComSvcPerAgc;
      chartData = this.twoSvcPerAgc;
      elementId = 'comSvcChart';
      console.log('statComSvcPerAgc');
      console.log(this.statComSvcPerAgc);  
    } else {
      chartData = this.statTrPerAgc;
      elementId = 'trChart';
    }

    let vTitle = this.translate.instant('statistic.label.svcvaxis');
    let hTitle = this.translate.instant('statistic.label.svchaxis');
     
      if(chartData && chartData.length>1) {
        google.charts.setOnLoadCallback(()=> {
          drawChart(chartData, elementId, vTitle, hTitle, chartType);
          setTimeout(()=>{
            $('g > text').css('font-size', this.fontSize.sizeS);
            $('g > text').css('font-family', this.fontType);
          }, 1000);
        });
      }
   
    function drawChart(graphData, elementId, vTitle, hTitle, chartType?) {
      if (!chartType) {
        chartType = 'ColumnChart';
      }
      let data = new google.visualization.arrayToDataTable(graphData);
      var view = new google.visualization.DataView(data);
      var columnRange = data.getColumnRange(1);
      let yMax;
      if (columnRange.max <5) {
        yMax = 5;
      } else {
        yMax = columnRange.max+(columnRange.max*0.01);
      }
      var groupData = google.visualization.data.group(data,
        [{column: 0, modifier: function () {return 'total'}, type:'string'}],
        [{column: 1, aggregation: google.visualization.data.sum, type: 'number'}]
      );
      var formatPercent = new google.visualization.NumberFormat({
        pattern: '#,##0.0%'
      });

      function getText(val1, val2) {
        var percent = formatPercent.formatValue(val1 / val2);
        if (percent == 'NaN') {
          percent = '0.0%';
        }
        return percent;
      }
      view.setColumns([0, 1,
                         {
          calc: function (dt, row) {
            //var amount = formatShort.formatValue(dt.getValue(row, 1));
            var percent = formatPercent.formatValue(dt.getValue(row, 1) / groupData.getValue(0, 1));
            if (percent == 'NaN') {
              percent = '0.0%';
            }
            return percent;
          },
          type: 'string',
          role: "annotation"
        }, {
          calc: function (dt, row) {
            return dt.getValue(row, 0) + ' - ' + dt.getFormattedValue(row, 1) + ' ('+ getText(dt.getValue(row, 1), groupData.getValue(0, 1)) + ')';
          },
          role: 'annotationText',
          type: 'string'
        }]);
      
      let options = {
        height: 420,
        width: '100%',
        isStacked: false,
        //colors: ["#05f7ec"],
        annotations: {
          textStyle: {
            color: 'black',
            bold: true,
            auraColor: 'transparent'
          },
          alwaysOutside: true
        },
        legend: {position:'none'},
        hAxis: { title: hTitle, direction:-1, slantedText:true, slantedTextAngle:30 },
        vAxis: {
          title: vTitle,
          logScale: true, 
          viewWindow: {  max: yMax, min: 0 }, 
          viewWindowMode: "explicit" },
          textStyle : {
            fontSize: 17
          },
          pieSliceText: 'none',
          pieSliceTextStyle: {
          fontSize: 5
          },
          sliceVisibilityThreshold: 0.0000001,
          pieStartAngle: 100,
          
          //pieSliceText: 'value-and-percentage'
        }
        if (chartType == 'PieChart') {
           options.legend = { position: 'labeled'};
        } else {
           options["colors"] = ['#05f7ec'];
        }
      //let chart = new google.visualization.ColumnChart(document.getElementById(elementId));
      //chart.draw(view, google.charts.Bar.convertOptions(options));
      var chart = new google.visualization.ChartWrapper({
        containerId: elementId
     });
     chart.setOptions(options);
     chart.setChartType(chartType);
     chart.setDataTable(view);
     chart.draw();
    
      /*var handler = function(e) {
        var parts = e.targetID.split('#');
        if (parts[0]=='hAxis' && parts[3]) {
          console.log(parts[3]);
          alert(data.getValue(parseInt(parts[3]), 0));
        } else if(parts[0]=='bar' && parts[2]) {
          console.log(parts[2]);
          alert(data.getValue(parseInt(parts[2]), 0));
        }
     
    };
    google.visualization.events.addListener(chart, 'click', handler);*/
    }

  }

  generateUserChartData(lang?) {

    let allUserLabel  = this.translate.instant('statistic.label.allusers');
    let newUserLabel = this.translate.instant('statistic.label.newusers');
    let gHeader = ['Month', allUserLabel, newUserLabel];
    this.graphByYearCopy = JSON.parse(JSON.stringify(this.graphByYear));
    
    this.graphByYearCopy.forEach(el => {
     let mName =  this.translate.instant('statistic.months.short.'+el[0]);
     el[0] = mName;
    });

    this.graphByYearCopy.unshift(gHeader); 
  }

  getDserviceCommonReport(lng, year) {

    let aryObj: any;
    let retn = [];
    let sum: any;

    let agcList: any = [];
    let trList: any = [];
    let trChart: any = [];
    let trChartObj: any = [];
   

    aryObj = {
      mName: "",
      mVal: ""
    };

    this.loading = true;

    if (!year) {
      year = this.getCurrYear;
    }
    
    this.StatByYearDservice = [{"name":"01","val":0},{"name":"02","val":0},{"name":"03","val":0},{"name":"04","val":0},{"name":"05","val":0},{"name":"06","val":0},{"name":"07","val":0},{"name":"08","val":0},{"name":"09","val":0},{"name":"10","val":0},{"name":"11","val":0},{"name":"12","val":0}];

    this.portalservice.getCommonDserviceRptData(lng, year).subscribe(data => {
      this.statComSvcPerAgc = [];
      this.statComSvcPerAgc.push(['Agency Name', this.translate.instant('statistic.label.total') + ' ' + this.translate.instant('statistic.label.transaction')]);
      this.dServiceCommonData = data.list;
      this.dserviceByYear = this.StatByYearDservice;
      console.log({'this.dServiceCommonData': this.dServiceCommonData});

      this.dServiceCommonData.forEach(cdsvc => {
        let agencyTotal  = 0;

        if(cdsvc.dserviceDetails) {
          cdsvc.dserviceDetails.forEach(svc => {
            trChartObj = [];
            if(svc.report) {
              
                Object.keys(svc.report).map(function (inx) {
                  aryObj = new Object;
    
                  if(inx != "id") {
                    aryObj.name = inx;
                    // svc.report[inx] = parseInt(svc.report[inx])+100000;  // TESTING PURPOSE ONLY
                    aryObj.val = svc.report[inx];
                    aryObj.fval = svc.report[inx].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    retn.push(aryObj);
                    trChartObj.push([aryObj.name,  aryObj.val]);
                  }
    
                });
    
                retn.forEach(el => {
                  el.name = this.convertMonthName(el.name);
                });

                svc.report = retn;
                sum = retn.reduce((sum, item) => sum + item.val, 0);
                svc.rptTotal = sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                //agencyTotal = agencyTotal+parseInt(svc.rptTotal);
                agencyTotal = agencyTotal+sum;
                 
                
              } else { // null reports
                svc.report = this.StatByYearDservice;
                retn.push(svc.report);
                svc.rptTotal = 0;
                trChartObj = this.statTrByYear;
              }
              if (cdsvc.agencyCode == '101') {
                cdsvc.agencyCode = cdsvc.agencyCode+0.1;
                cdsvc.agencyName = this.translate.instant('statistic.label.mampunameforcomservice');
              }
              trList.push({'agencyCode': cdsvc.agencyCode, 'agencyName': cdsvc.agencyName, 'trCode': svc.code, 'title' : svc.title});
              trChart.push({'agencyCode': cdsvc.agencyCode, 'agencyName': cdsvc.agencyName, 'trCode': svc.code, 'title' : svc.title, 'chartData': trChartObj });
              retn = [];

          });
        }

        cdsvc.agencyTotal = agencyTotal;
        this.statComSvcPerAgc.push([cdsvc.agencyName, agencyTotal]);
        agcList.push({'agencyCode': cdsvc.agencyCode, 'agencyName': cdsvc.agencyName});

        });
        
      this.loading = false;

      this.statAgcComSvcList = agcList;

      //Combine two agency name list
      //this.twoAgcList = this.statAgcList.concat(this.statAgcComSvcList);
      //this.statAgcComSvcList.unshift({'agencyCode': '', 'agencyName': this.translate.instant('statistic.label.all')} )
      
      let duplicateAgcList = this.statAgcList.concat(this.statAgcComSvcList);
      this.twoAgcList = Array.from(new Set(duplicateAgcList.map(a => a.agencyCode)))
      .map(id => {
        return duplicateAgcList.find(a => a.agencyCode === id)
      });

      this.currComAgencyCode = '';
      this.statComSvcList = trList;

      //Combine two service name list
      this.twoSvcList = this.statTrList.concat(this.statComSvcList);
      this.twoSvcList.unshift({'agencyCode': '', 'agencyName': this.translate.instant('statistic.label.all')} )
      this.statComSvcChartData = trChart;
   
      // Combine two Chart Data
      this.twoSvcChartData = this.statTrChartData.concat(this.statComSvcChartData);
      console.log('this.twoSvcChartData', this.twoSvcChartData);
      
      // Combine two Overall Chart
      this.twoSvcPerAgc = this.statComSvcPerAgc.concat(this.statTrPerAgc);
      
      //  Merge and Avoid duplicate Agency for TR Service Data and Common Service Data
      this.newServiceData = JSON.parse(JSON.stringify(this.dServiceData));
      this.dServiceData.forEach((item, index) => {
        let foundItem  = this.dServiceCommonData.find(commonItem => item.agencyCode === commonItem.agencyCode);
        if (foundItem) {
          this.newServiceData[index].dserviceDetails = this.dServiceData[index].dserviceDetails.concat(foundItem.dserviceDetails);
          let agencyTotal = this.dServiceData[index].agencyTotal;
          this.newServiceData[index].agencyTotal = agencyTotal+foundItem.agencyTotal; 
          console.log('foundItem', foundItem);
        }
      });
      this.dServiceCommonData.forEach(arr2Item => this.newServiceData.find(({ agencyCode }) => agencyCode === arr2Item.agencyCode) || this.newServiceData.push(arr2Item));
      console.log('this.newServiceData', this.newServiceData);

      this.generateAgcTrChart('Common');
      

    });

  }

  getDserviceReport(lng, year?) {
    let aryObj: any;
    let retn = [];
    let sum: any;

    let agcList: any = [];
    let trList: any = [];
    let trChart: any = [];
    let trChartObj = [];

    aryObj = {
      mName: "",
      mVal: ""
    };

    this.loading = true;

    if (!year) {
      year = this.getCurrYear;
    }

    this.StatByYearDservice = [{"name":"01","val":0},{"name":"02","val":0},{"name":"03","val":0},{"name":"04","val":0},{"name":"05","val":0},{"name":"06","val":0},{"name":"07","val":0},{"name":"08","val":0},{"name":"09","val":0},{"name":"10","val":0},{"name":"11","val":0},{"name":"12","val":0}];

    this.portalservice.getDserviceRptData(lng, year).subscribe(data => {
      this.statTrPerAgc = [];
      //this.statTrPerAgc.push(['Agency Name', this.translate.instant('statistic.label.total') + ' ' + this.translate.instant('statistic.label.transaction')]);
      this.dServiceData = data.list;
      this.dserviceByYear = this.StatByYearDservice;

      this.dServiceData.forEach(dsvc => {
        let agencyTotal  = 0;
      
        if(dsvc.dserviceDetails) {
       
          dsvc.dserviceDetails.forEach(svc => {
            trChartObj = [];
            if(svc.report) {
              
                Object.keys(svc.report).map(function (inx) {
                  aryObj = new Object;
                
                  if(inx != "id") {
                    aryObj.name = inx;
                    // svc.report[inx] = parseInt(svc.report[inx])+100000;  // TESTING PURPOSE ONLY
                    aryObj.val = svc.report[inx];
                    aryObj.fval = svc.report[inx].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); 
                    retn.push(aryObj);   
                    trChartObj.push([aryObj.name,  aryObj.val]);
                  }
                });
    
                retn.forEach(el => {
                  el.name = this.convertMonthName(el.name);
                });
                
                svc.report = retn;
                sum = retn.reduce((sum, item) => sum + item.val, 0);
                svc.rptTotal = sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); // .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                //agencyTotal = agencyTotal+parseInt(svc.rptTotal);
                agencyTotal = agencyTotal+sum; 
               
              } else { // null reports
                svc.report = this.StatByYearDservice;
                retn.push(svc.report);
                svc.rptTotal = 0;
              
                trChartObj = this.statTrByYear;
             
              }

              if (dsvc.agencyCode == '101') {
                dsvc.agencyName = this.translate.instant('statistic.label.mampunamefortranservice');
                //dsvc.agencyCode = dsvc.agencyCode+0.1;
              }

              
              trList.push({'agencyCode': dsvc.agencyCode, 'agencyName': dsvc.agencyName, 'trCode': svc.code, 'title' : svc.title});
              trChart.push({'agencyCode': dsvc.agencyCode, 'agencyName': dsvc.agencyName, 'trCode': svc.code, 'title' : svc.title, 'chartData': trChartObj });
              //console.log({'retn':retn});
              retn = [];

          });
         
        }

        dsvc.agencyTotal = agencyTotal;
        this.statTrPerAgc.push([dsvc.agencyName, agencyTotal]);
        agcList.push({'agencyCode': dsvc.agencyCode, 'agencyName': dsvc.agencyName});
         
        });
        
        this.loading = false;
        this.statAgcList = agcList;
        this.statAgcList.unshift({'agencyCode': '', 'agencyName': this.translate.instant('statistic.label.all')} )
        this.currAgencyCode = '';
        this.statTrList = trList;
        this.statTrChartData = trChart;
        
        //console.log(JSON.stringify(this.statTrPerAgc));
        //console.log(this.statAgcList);
        //console.log(this.statTrList);
        console.log('DService');
        console.log(this.statTrChartData);
        this.getDserviceCommonReport(this.languageId, year);
        //this.generateAgcTrChart();

    });
  }

  generateYearList() {
    let max = new Date().getFullYear();
    this.selectedYear = max;
    let min = 2017;

    for (let i = min; i<=max; i++) {
      this.yearList.push({'year': i});
    }

  }

  yearSelectedChange(val) {
    console.log(val);
    this.newUsers = null;
    this.allUsers = null;
    this.selectedYear = val; 
    this.dataCheck = [];
    this.portalservice.triggerStatistic(1, this.selectedYear);
    this.portalservice.triggerStatistic(2, this.selectedYear);
    this.currAgencyCode = null;
    this.currTrCode = null;
    this.currPAgencyCode = null;
    this.currPSvcCode = null;
    this.currComAgencyCode = null;
    this.currComSvcCode = null;
    this.flrTrList = [];
    this.flrPSvcList = [];
    this.flrSvcList = [];
    this.twoAgcList =[];
    this.twoSvcList =[];
    this.userColumnChart = 'block';
    this.userPieChart = 'none';
    this.getDserviceReport(this.languageId, this.selectedYear);
    this.getPendingDserviceReport(this.languageId, this.selectedYear); 
  }

  agencySelectedChange(val, type?) {
    console.log(val);
    if(!val && type == 'Common') {
      this.flrSvcList = [];
      this.currComSvcCode = '';
      this.getDserviceReport(this.languageId, this.selectedYear);
      $('#comSvcChartLabel').show();     
      return;
    } else if (!val && type == 'Pending') {
      this.flrPSvcList = [];
      this.currPSvcCode = '';
      this.getPendingDserviceReport(this.languageId, this.selectedYear);
      $('#pSvcChartLabel').show(); 
      return;
    }

    //console.log( this.twoSvcList);

    if (type == 'Pending') {
      this.flrPSvcList = [];
      this.currPSvcCode = '';
      this.flrPSvcList = this.statPSvcList.filter((element, index) => {
        return (element.agencyCode === val);
      });
      $('#pSvcChart').empty();
      $('#pSvcChartLabel').hide(); 
      //this.showChart('pSvcChart', 'ColumnChart');
    } else if (type == 'Common') {
      this.flrSvcList = [];
      this.currComSvcCode = '';
      console.log(this.twoSvcList);
      this.flrSvcList = this.twoSvcList.filter((element, index) => {
        return (element.agencyCode === parseFloat(val));
      });
      $('#comSvcChart').empty();
      $('#comSvcChartLabel').hide(); 

      //this.showChart('comSvcChart', 'ColumnChart');
    } else {
      this.flrTrList = this.statTrList.filter((element, index) => {
        return (element.agencyCode === parseFloat(val));
      });
      console.log(val);
      console.log(this.flrTrList);
    }   
    
  }

  trSelectedChange(val, type?) {
    //alert(this.currAgencyCode + '|'+ val);
    if (this.currAgencyCode && val && !type) {
      this.generateAgcTrDrillChart(parseFloat(this.currAgencyCode), parseInt(val));
      $('#comSvcChartLabel').show(); 
    } else if (this.currPAgencyCode && val && type == 'Pending') {
      this.generateAgcTrDrillChart(parseFloat(this.currPAgencyCode), parseInt(val), type);
      $('#pSvcChartLabel').show(); 
    } else if (this.currComAgencyCode && val && type == 'Common') {
      this.generateAgcTrDrillChart(parseFloat(this.currComAgencyCode), parseInt(val), type);
      $('#comSvcChartLabel').show(); 
    }
  }

  changeAryVal(objs) {

    let aryObj: any;
    let retn = [];

    aryObj = {
      svcName: null,
      svcData: null,
      svcTotal: null,
      svcAgcName: null
    };

    Object.keys(objs).map(function (inx) {
      aryObj = new Object;

      console.log({'objs':objs})

      // aryObj.title = objs[inx].title;
      // aryObj.description = objs[inx].description;
      // aryObj.url = objs[inx].url;
      // aryObj.date = objs[inx].date;
      // aryObj.checked = true;
      

      // do something with person
      // retn.push(aryObj);
    });
    
    return retn;
  }

  getTheme() {
    this.themeColor = localStorage.getItem('themeColor');
    return localStorage.getItem('themeColor');
  }

  getPendingDserviceReport(lng, year?) {

    let aryObj: any;
    let retn = [];
    let sum: any;

    let agcList: any = [];
    let trList: any = [];
    let trChart: any = [];
    let trChartObj = [];
    

    aryObj = {
      mName: "",
      mVal: ""
    };

    this.loading = true;

    if (!year) {
      year = this.getCurrYear;
    }

    this.portalservice.getPendingDserviceRptData(lng, year).subscribe(data => {
      this.statPSvcPerAgc = [];
      this.statPSvcPerAgc.push(['Agency Name', this.translate.instant('statistic.label.total') + ' ' + this.translate.instant('statistic.label.transaction')]);
      this.dServicePendingData = data.list;

      this.dServicePendingData.forEach(pdsvc => {
        let agencyTotal  = 0;

        if(pdsvc.dserviceDetails) {
          pdsvc.dserviceDetails.forEach(svc => {
            trChartObj = [];
            if(svc.report) {
             
                Object.keys(svc.report).map(function (inx) {
                  aryObj = new Object;
    
                  if(inx != "id") {
                    aryObj.name = inx;
                    // svc.report[inx] = parseInt(svc.report[inx])+100000;  // TESTING PURPOSE ONLY
                    aryObj.val = svc.report[inx];
                    aryObj.fval = svc.report[inx].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    // api[1] = parseInt(api[1])+1000000;

                    retn.push(aryObj);
                    trChartObj.push([aryObj.name,  aryObj.val]);
                  }
    
                });
    
                retn.forEach(el => {
                  el.name = this.convertMonthName(el.name);
                });

                svc.report = retn;
                sum = retn.reduce((sum, item) => sum + item.val, 0);
                svc.rptTotal = sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                //agencyTotal = agencyTotal+parseInt(svc.rptTotal); 
                agencyTotal = agencyTotal+sum;

              } else { // null reports
                svc.report = this.StatByYearDservice;
                retn.push(svc.report);
                svc.rptTotal = 0;

                trChartObj = this.statTrByYear;
              }

              if (pdsvc.agencyCode == '101') {
                pdsvc.agencyName = this.translate.instant('statistic.label.mampunamefortranservice');
              }

              trList.push({'agencyCode': pdsvc.agencyCode, 'agencyName': pdsvc.agencyName, 'trCode': svc.code, 'title' : svc.title});
              trChart.push({'agencyCode': pdsvc.agencyCode, 'agencyName': pdsvc.agencyName, 'trCode': svc.code, 'title' : svc.title, 'chartData': trChartObj });
              retn = [];

          });
        }

        pdsvc.agencyTotal = agencyTotal;
        this.statPSvcPerAgc.push([pdsvc.agencyName, agencyTotal]);
        agcList.push({'agencyCode': pdsvc.agencyCode, 'agencyName': pdsvc.agencyName});

        });

        this.loading = false;
        this.statAgcPSvcList = agcList;
        this.statAgcPSvcList.unshift({'agencyCode': '', 'agencyName': this.translate.instant('statistic.label.all')} )
        this.currPAgencyCode = '';
        this.statPSvcList = trList;
        this.statPSvcChartData = trChart;
        this.generateAgcTrChart('Pending');

    });
  }

  getUsersStatData(type) {

    this.allUsersByYear = []; 
    this.newUsersByYear = [];

      if (type == 1) {
        this.StatByYearAll = [["01", "0"], ["02", "0"], ["03", "0"], ["04", "0"], ["05", "0"], ["06", "0"], ["07", "0"], ["08", "0"], ["09", "0"], ["10", "0"], ["11", "0"], ["12", "0"]];
        this.allUsersByYear = this.StatByYearAll;

        this.StatByYearAll.forEach(el => {
          this.statisticservice.allUser.forEach(api => {
            if (el[0] === api[0]) {
              // api[1] = parseInt(api[1])+1000000; // TESTING PURPOSE ONLY
              el[1] = api[1].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              // console.log(el[1])
            }
          });
          this.allUsers = this.allUsersByYear;
        });

        this.graphByYear.forEach(el => {
          el[1] = 0;
        });
        
        this.graphByYear.forEach(el => {
          this.statisticservice.allUser.forEach(api => {
            if (el[0] === api[0]) { 
              el[1] = parseInt(api[1]);          
            }
          });

        });

      } else if (type == 2) {
        this.StatByYearNew = [["01", "0"], ["02", "0"], ["03", "0"], ["04", "0"], ["05", "0"], ["06", "0"], ["07", "0"], ["08", "0"], ["09", "0"], ["10", "0"], ["11", "0"], ["12", "0"]];
        this.newUsersByYear = this.StatByYearNew;

        this.newUsersByYear.forEach(el => {
          this.statisticservice.newUser.forEach(api => {
              if (el[0] === api[0]) {
                // api[1] = parseInt(api[1])+1000000; // TESTING PURPOSE ONLY
                el[1] = api[1].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                // console.log(el[1])
              }
            });
            this.newUsers = this.newUsersByYear;
          });

          this.graphByYear.forEach(el => {
            el[2] = 0;
          });

          this.graphByYear.forEach(el => {
            this.statisticservice.newUser.forEach(api => {
              if (el[0] === api[0]) { 
                el[2] = parseInt(api[1]);          
              }
            });
          });
      }

    

  }

  generateStatByYearFor(name:String) {
    let objName:String = name;
    let StatByYear: any = [["01", "0"], ["02", "0"], ["03", "0"], ["04", "0"], ["05", "0"], ["06", "0"], ["07", "0"], ["08", "0"], ["09", "0"], ["10", "0"], ["11", "0"], ["12", "0"]]
    let genObj = {objName:StatByYear};
    return genObj;
  }

  convertMonthName(objName:String) {

    let objElem;

    switch (objName) {

      case "jan":
        objElem = "01"
        break;

      case "feb":
        objElem = "02"
        break;

      case "mar":
        objElem = "03"
        break;

      case "apr":
        objElem = "04"
        break;

      case "may":
        objElem = "05"
        break;

      case "jun":
        objElem = "06"
        break;

      case "jul":
        objElem = "07"
        break;

      case "aug":
        objElem = "08"
        break;

      case "sep":
        objElem = "09"
        break;

      case "oct":
        objElem = "10"
        break;

      case "nov":
        objElem = "11"
        break;

      case "dec":
        objElem = "12"
        break;

    }
    return objElem;
  }
}



// WEBPACK FOOTER //
// ./src/app/statistic/statistic.component.ts